import { render, staticRenderFns } from "./SortingDropdown.vue?vue&type=template&id=67563c44&scoped=true&"
import script from "./SortingDropdown.vue?vue&type=script&lang=js&"
export * from "./SortingDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67563c44",
  null
  
)

export default component.exports